import React, { useState, useRef, useEffect } from "react";

import DynamicForm from "f1-dynamic-form-react";
import Loader from "../components/loader/loader";
import { PRODUCT_FORM, customValidators, Inventory_Data } from "./formData";
import { format } from "date-fns";

import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useNavigate } from "react-router-dom";

import { post } from "../api/api";
import axios from "axios";
import ModalPopup from "f1-modal-react";
import { Button } from "@material-ui/core";
import { useCallback } from "react";
import Webcam from "react-webcam";
import {
  ApiUrls
} from "../api/baseURL";
import useOnlineStatus from "../useOnlineStatus";
import { getProductOffline, saveProductOffline, updateProductOffline } from "../offlineManager/inventoryOffline";
import { add, getAllOfTable } from "../offlineManager/localbase";
import { metaDataConstants } from "../utils/Constants/constants-en";
import { getDateWithFormat } from "../utils/utils";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
const dateFormate = "MM-dd-yyyy HH:mm:ss";

const ProductDetail = () => {
  let dyFormRef = useRef();
  const store = useSelector(state => state);
  console.log(store)
  const webcamRef = useRef(null); // create a webcam reference
  const [imgSrc, setImgSrc] = useState(null);
  const [barcodeNo, setBarcodeNo] = useState(null);
  let naviagte = useNavigate();
  const dispatch = useDispatch();

  const [umoID, setUmoID] = useState(null);
  const [lcationstorage, setLcationstorage] = useState(0)
  const capture = useCallback(async () => {
    setActivateLoader(true);
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
    var result = imageSrc.substr(imageSrc.indexOf(",") + 1);
    const response = await axios.post(ApiUrls().PROCESSCODE_BY_FLASK_API, {
      base64: result,
    });
    if (response?.data == "Success") {
      setCenterSnackDuration(2000)
      setShowMessage(true);
      setStatus("error");
      setServityMessage(metaDataConstants.codeNotScanned);
    }
    if (response?.data.scannedCode) {
      setCenterSnackDuration(2000)
      setShowMessage(true);
      setStatus("success");
      setServityMessage(`barcode no is ${response?.data.scannedCode}`);
    }
    setBarcodeNo(response?.data.scannedCode);
    setIsshowButton(false);
    setActivateLoader(false);
  }, [webcamRef]);

  const retake = () => {
    setImgSrc(null);
    setBarcodeNo(null);
    setIsshowButton(true);
  };
  const videoConstraints = {
    facingMode: "environment", // Use the rear camera
  };

  const [activateLoader, setActivateLoader] = useState(false);
  const [candidateDetail, setCandidateDetail] = useState(PRODUCT_FORM);
  const [barcodeData, setBarcodeData] = useState({
    barcodenumber: null,
    productid: null,
    productCode: null,
    productname: null,
    inventoryunit: null,
    previousquantity: null,
    unitprice: null,
    updatenewquaninty: '',
    vendorId: null
  });
  const [show, setShow] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [status, setStatus] = useState("");
  const [servitymessage, setServityMessage] = useState("");
  const [serverityStatus, setServerityStatus] = useState("");
  const [message, setMessage] = useState("");
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isfirstvisit, setIsfirstvisit] = useState(true);
  const [showModalCamera, setShowModalCamera] = useState(false);
  const [modelHeaderContent, setModelHeaderContent] = useState("")
  const isOnline = useOnlineStatus();
  const [createdDate, setCreatedDate] = useState(
    getDateWithFormat(dateFormate)
  );
  const [centerSnackDuration, setCenterSnackDuration] = useState(2000);
  const [isshow, setIsShow] = useState(true);
  const [isshowScan, setIsShowScan] = useState(true);
  const [unitTotalQuantityUOMId, setUnitTotalQuantityUOMId] = useState(0);
  const [isshowButton, setIsshowButton] = useState(true);
  const [current, setCurrent] = useState({
    barcodenumber: null,
    productid: null,
    productCode: null,
    productname: null,
    inventoryunit: null,
    previousquantity: null,
    unitprice: null,
    updatenewquaninty: '',
    Remarks: null,
  });

  const [umoId, setUmoId] = useState({
    uomId1: 0,
    uomEnteredStock1: 0,
    uomPreviousEnteredStock1: 0,
    uomId2: 0,
    uomEnteredStock2: 0,
    uomPreviousEnteredStock2: 0,
    uomId3: 0,
    uomEnteredStock3: 0,
    uomPreviousEnteredStock3: 0,
    uomId4: 0,
    uomEnteredStock4: 0,
    uomPreviousEnteredStock4: 0,
    uomId6: 0,
    uomEnteredStock6: 0,
    uomPreviousEnteredStock6: 0,
    firtstScan: false,
  });

  useEffect(() => {
    const firstVisit = localStorage.getItem("isfirstvisit")
    const isOnlineSyncRequired = localStorage.getItem("isOnlineSyncRequired")
    const isofflineproductsadded = localStorage.getItem("isofflinelocproductsadded");

    if (isOnline && firstVisit == 1) {
      localStorage.setItem("isfirstvisit", 0)
    }
    if (isOnline && isofflineproductsadded != "true" && !isfirstvisit) {
      getInventoryCheckDetail();
    }
    if (isOnline && isOnlineSyncRequired == "true") {

      localStorage.setItem("isOnlineSyncRequired", false)
    }

  }, [isOnline])

  // Update function to maintain previous state
  const updateUmoId = (updates) => {
    setUmoId((prevUmoId) => {
      const newState = { ...prevUmoId };
      if (updates.firtstScan) {
        newState.firtstScan = false;
        Object.keys(updates).forEach((key) => {
          if (key.startsWith("uomEnteredStock")) {
            const prevKey = key.replace("uomEnteredStock", "uomPreviousEnteredStock");
            newState[prevKey] = updates[key];
          }
        });
      }
      return { ...newState, ...updates };
    });
  };

  const [data, setData] = useState({
    transactionStatusId: null,
    moduleWorkFlowRuntimeId: null,
  });

  const [inventoryCheckData, setInventoryCheckData] = useState([]);
  const [inventoryCheckDataOffline, setInventoryCheckDataOffline] = useState([]);
  const [pricingDataOffline, setPricingDataOffline] = useState([]);
  const [state, setState] = useState({
    activateLoader: false,
    show: false,
    serverityStatus: "",
    message: "",
  });
  const [barcodeDataDB, setBarcodeDataDB] = useState([])
  const [productStorageDataDB, setProductStorageDataDB] = useState([])
  // Data type: 'boolean', 'numeric', 'date', 'datetime', 'time', 'currency'
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShow(false);
    setShowMessage(false);
  };

  const focusTextInput = () => {
    document.querySelector("#barcodenumber").focus();
  };

  useEffect(() => {
    localStorage.setItem("quantity", 0);
    getBarcodeData()
    getProductStorageDetails()
    if (isOnline) {
      getInventoryCheckDetail();
    }
    getInventoryCheckDetailOffline()

    setBreadcrumbs([
      { name: "Dashboard", url: "/home" },
      { name: "2d-Barcode Scanner" },
    ]);
    setCreatedDate(getDateWithFormat(dateFormate));
    setIsfirstvisit(false);
    focusTextInput();
  }, []);

  useEffect(() => {
    if (store.sync == true){
      getInventoryCheckDetail()
      getInventoryCheckDetailOffline()
      setBarcodeData({
        ...barcodeData,
        barcodenumber: null,
        productid: null,
        productCode: null,
        productname: null,
        inventoryunit: null,
        previousquantity: null,
        unitprice: null,
        updatenewquaninty: '',
        vendorId: null
      });
      setCurrent({
        ...current,
        barcodenumber: '',
        productid: '',
        productCode: '',
        productname: '',
        inventoryunit: '',
        previousquantity: '',
        unitprice: '',
        updatenewquaninty: '',
        Remarks: '',
      });
      dispatch({type: 'RESET_SYNC'})
    }
  }, [store])

  const getBarcodeData = async () => {
    return new Promise((resolve, reject) => {
      getAllOfTable('BarcodeDetails').then((res) => {
        resolve(res[0].barcodeDetails)
        setBarcodeDataDB(res[0].barcodeDetails)
      }).catch((err) => reject(false))
    })
  };

  const getProductStorageDetails = async () => {
    return new Promise((resolve, reject) => {
      getAllOfTable('ProductStorageDetails').then((res) => {
        resolve(res[0].productStorageDetails)
        setProductStorageDataDB(res[0].productStorageDetails)
      }).catch((err) => reject(false))
    })

  };

  const getInventoryCheckDetail = async () => {
    const payload = {
      id: localStorage.getItem("InventoryCheckId"),
      WorkflowModuleKey: "INVENTORY_COUNT_FILL",
      ModuleKey: 1,
      timeOffset: -330,
    };

    setActivateLoader(true);
    const response = await post(ApiUrls().INVENTORY_CHECK_DETAIL, payload).catch(
      function (error) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      }
    );

    if (response?.status === 200) {
      setActivateLoader(false);
      setData({
        ...data,
        transactionStatusId: response?.data.result?.transactionStatusId,
        moduleWorkFlowRuntimeId: response?.data.result?.moduleWorkFlowRuntimeId,
      });
      getInventoryCheck();
    } else {
      setActivateLoader(false);
    }
  };
  const getInventoryCheck = async () => {
    const payload = {
      AccountId: localStorage.getItem("account"),
      LocationId: localStorage.getItem("location"),
      LocationStorageId: localStorage.getItem("LocationStorageId"),
      ProductName: "",
      IsActive: 1,
      InventoryCheckId: localStorage.getItem("InventoryCheckId"),
    };

    setActivateLoader(true);
    const response = await post(ApiUrls().INVENTORY_CHECK_PRODUCT, payload).catch(
      function (error) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      }
    );

    if (response?.status === 200) {
      setActivateLoader(false);
      setInventoryCheckData(response?.data.result);
      if (response?.data.result.length != 0) {
        setUnitTotalQuantityUOMId(
          response?.data.result[0]?.unitTotalQuantityUOMId
        );
      }
    } else {
      setActivateLoader(false);
    }
  };
  const getInventoryCheckDetailOffline = async () => {
    return new Promise((resolve, reject) => {
      getAllOfTable('PreviousQuantityDetails').then((res) => {
        resolve(res[0].previousQuantityDetails)
        setInventoryCheckDataOffline(res[0].previousQuantityDetails);
      }).catch((err) => reject(false))
    })
  };

  const onSubmitHandler = async (model) => {
    if (model.productid !== null && model.productid !== "") {
      delete model.errors.productid;
    }
    if (model.previousquantity !== null && model.previousquantity !== "") {
      delete model.errors.previousquantity;
    }
    if (model.unitprice !== null && model.unitprice !== "") {
      delete model.errors.unitprice;
    }
    if (model.updatenewquaninty !== null && model.updatenewquaninty !== "") {
      delete model.errors.updatenewquaninty;
    }
    if (
      (!model.isValidForm && Object.keys(model.errors).length > 0) ||
      Object.keys(model.errors).length > 0
    ) {
      return false;
    }
    if (
      model.productid === null ||
      model.productid == "" ||
      model.unitprice === null ||
      model.unitprice == "" ||
      model.inventoryunit === null ||
      model.inventoryunit == "" ||
      model.updatenewquaninty === null ||
      model.productname === null ||
      model.productname == "" ||
      model.updatenewquaninty == ""
    ) {
      setShow(true);
      setServerityStatus("error");
      setMessage(metaDataConstants.fillAllFields);
      return false;
    }
    setActivateLoader(true);
    let invId = localStorage.getItem("InventoryCheckId")
    if (isOnline) {
      const res = inventoryCheckData?.filter(
        (ele) => ele.productId == model.productid
      );
      if (res.length > 0) {
        const totalQuantity =
          umoId.uomEnteredStock1 * (res[0]?.uomConversion1 ? res[0]?.uomConversion1 : 0) +
          umoId.uomEnteredStock2 * (res[0]?.uomConversion2 ? res[0]?.uomConversion2 : 0) +
          umoId.uomEnteredStock3 * (res[0]?.uomConversion3 ? res[0]?.uomConversion3 : 0) +
          umoId.uomEnteredStock4 * (res[0]?.uomConversion4 ? res[0]?.uomConversion4 : 0) +
          umoId.uomEnteredStock6 * (res[0]?.uomConversion6 ? res[0]?.uomConversion6 : 0);
        const payload = {
          ProductInventoryXml: `<root><node><Header><InventoryCheckId>${localStorage.getItem(
            "InventoryCheckId"
          )}</InventoryCheckId><LocationStorageId>${localStorage.getItem(
            "LocationStorageId"
          )}</LocationStorageId><ProductId>${model.productid}</ProductId><UOMId1>${umoId.uomId1
            }</UOMId1><UOMPreviousEnteredStock1>${umoId.uomPreviousEnteredStock1
            }</UOMPreviousEnteredStock1><UOMEnteredStock1>${umoId.uomEnteredStock1
            }</UOMEnteredStock1><UOMId2>${umoId.uomId2}</UOMId2><UOMPreviousEnteredStock2>${umoId.uomPreviousEnteredStock2
            }</UOMPreviousEnteredStock2><UOMEnteredStock2>${umoId.uomEnteredStock2
            }</UOMEnteredStock2><UOMId3>${umoId.uomId3}</UOMId3><UOMPreviousEnteredStock3>${umoId.uomPreviousEnteredStock3
            }</UOMPreviousEnteredStock3><UOMEnteredStock3>${umoId.uomEnteredStock3
            }</UOMEnteredStock3><UOMId4>${umoId.uomId4}</UOMId4><UOMPreviousEnteredStock4>${umoId.uomPreviousEnteredStock4
            }</UOMPreviousEnteredStock4><UOMEnteredStock4>${umoId.uomEnteredStock4
            }</UOMEnteredStock4><UOMId6>${umoId.uomId6}</UOMId6><UOMPreviousEnteredStock6>${umoId.uomPreviousEnteredStock6
            }</UOMPreviousEnteredStock6><UOMEnteredStock6>${umoId.uomEnteredStock6
            }</UOMEnteredStock6><UnitTotalQuantityUOMId>${unitTotalQuantityUOMId || 0}</UnitTotalQuantityUOMId><UnitTotalQuantity>${totalQuantity}</UnitTotalQuantity><AccountId>${localStorage.getItem(
              "account"
            )}</AccountId></Header></node></root>`,
          ProductStorageXml:
            "<Products><Product><ProductId>undefined</ProductId><MinParQty>0</MinParQty><MinParUOMId>undefined</MinParUOMId><StorageIds>0</StorageIds></Product></Products>",
          AccountId: localStorage.getItem("account"),
          LocationId: localStorage.getItem("location"),
          LocationStorageIds: localStorage.getItem("LocationStorageId"),
          IsActive: 1,
          InventoryCheckId: invId,
        };
        const response = await post(ApiUrls().UPDATE_INVENTORY, payload).catch(function (error) {
          setActivateLoader(false);
          localStorage.setItem("quantity", 0)
          // Handle errors here
          if (error?.data?.message === "GNPWA01") {
            // Countdown implementation
            let countdown = 3;
            const countdownInterval = setInterval(() => {
              if (countdown > 0) {
                setCenterSnackDuration(4000)
                setShowMessage(true);
                setStatus("info");
                setServityMessage(metaDataConstants.staleData.replace('countdown', countdown));
                countdown--;
              } else {
                clearInterval(countdownInterval);
                setCenterSnackDuration(2000)
                setShowMessage(true);
                setStatus("info");
                setServityMessage(metaDataConstants.syncingData);
                dispatch({ type: 'SYNC_REQUESTED' });
                setActivateLoader(false);
              }
            }, 1000); // Update every second
          }
        });
        if (response?.status === 200) {
          setModelHeaderContent(metaDataConstants.productSavedSuccess)
          localStorage.setItem("isOnlineSync", 1)
          localStorage.setItem("quantity", 0)
          const updatedInvArray = inventoryCheckData.map(item => {
            if (item.productId == model.productid) {
              return {
               ...item,
                unitTotalQuantity: totalQuantity,
                uomEnteredStock1: umoId.uomEnteredStock1,
                uomEnteredStock2: umoId.uomEnteredStock2,
                uomEnteredStock3: umoId.uomEnteredStock3,
                uomEnteredStock4: umoId.uomEnteredStock4,
              };
            } else {
              return item;
            }
          });
          setInventoryCheckData(updatedInvArray);
          const updatedOfflineInvArray = inventoryCheckDataOffline.map(item => {
            if (item.productId == model.productid && item.inventoryCheckId == invId) {
              return {
                ...item,
                unitTotalQuantity: totalQuantity,
                uomEnteredStock1: umoId.uomEnteredStock1,
                uomEnteredStock2: umoId.uomEnteredStock2,
                uomEnteredStock3: umoId.uomEnteredStock3,
                uomEnteredStock4: umoId.uomEnteredStock4
              };
            } else {
              return item;
            }
          })
          setInventoryCheckDataOffline(updatedOfflineInvArray)
          const dataObject = {
            previousQuantityDetails: updatedOfflineInvArray,
          };
          add("PreviousQuantityDetails", dataObject)
            .then((res) => {
              console.log(res)
              setActivateLoader(false)
              localStorage.setItem("isOnlineSyncRequired", true)
            })
            .catch((err) => console.log(err));
          setBarcodeData({
            ...barcodeData,
            barcodenumber: null,
            productid: null,
            productCode: null,
            productname: null,
            inventoryunit: null,
            previousquantity: null,
            unitprice: null,
            updatenewquaninty: '',
            vendorId: null
          });
          setCurrent({
            ...current,
            barcodenumber: '',
            productid: '',
            productCode: '',
            productname: '',
            inventoryunit: '',
            previousquantity: '',
            unitprice: '',
            updatenewquaninty: '',
            Remarks: '',
          });
          setActivateLoader(false);
          // window.location.reload()

        } else {
          setActivateLoader(false);
        }
      }
      else {
        setActivateLoader(false);
        setShow(true);
        setServerityStatus("error");
        setMessage(metaDataConstants.productNotInLocationOrStorage);
      }
    }
    else {
      const transactionData = JSON.parse(localStorage.getItem("transactionData"))
      const localdata = JSON.parse(localStorage.getItem("labelData"));
      const id = invId
      let resp;
      if (barcodeData?.vendorId == 0) {
        resp = productStorageDataDB?.filter((el) => el.productId == model.productid && el.accountId == localStorage.getItem("account"))
      } else {
        resp = productStorageDataDB?.filter((el) => el.productId == model.productid && el.vendorId == barcodeData?.vendorId && el.accountId == localStorage.getItem("account"))
      }
      const res = inventoryCheckDataOffline?.filter(
        (ele) => ele.productId == model.productid && ele.inventoryCheckId == id
      );
      if (resp.length > 0) {
        const totalQuantity =
          umoId.uomEnteredStock1 * (resp[0]?.vpConversionFactor1 ? resp[0]?.vpConversionFactor1 : 0) +
          umoId.uomEnteredStock2 * (resp[0]?.vpConversionFactor2 ? resp[0]?.vpConversionFactor2 : 0) +
          umoId.uomEnteredStock3 * (resp[0]?.vpConversionFactor3 ? resp[0]?.vpConversionFactor3 : 0) +
          umoId.uomEnteredStock4 * (resp[0]?.vpConversionFactor4 ? resp[0]?.vpConversionFactor4 : 0) +
          umoId.uomEnteredStock6 * (res[0]?.uomConversion6 ? res[0]?.uomConversion6 : 0);
        const payload = {
          AccountId: localStorage.getItem("account"),
          LocationId: localStorage.getItem("location"),
          LocationStorageIds: localStorage.getItem("LocationStorageId"),
          ProductName: model.productname,
          IsActive: 1,
          InventoryCheckId: invId,
          ProductId: model.productid,
          UOMId1: umoId.uomId1 == null ? 0 : umoId.uomId1,
          UOMEnteredStock1: umoId.uomEnteredStock1,
          UOMId2: umoId.uomId2 == null ? 0 : umoId.uomId2,
          UOMEnteredStock2: umoId.uomEnteredStock2,
          UOMId3: umoId.uomId3 == null ? 0 : umoId.uomId3,
          UOMEnteredStock3: umoId.uomEnteredStock3,
          UOMId4: umoId.uomId4 == null ? 0 : umoId.uomId4,
          UOMEnteredStock4: umoId.uomEnteredStock4,
          UOMId6: umoId.uomId6 == null ? 0 : umoId.uomId6,
          UOMEnteredStock6: umoId.uomEnteredStock6,
          UnitTotalQuantityUOMId: resp[0]?.inventoryUOMId,
          UnitTotalQuantity: totalQuantity,
          ModuleWorkFlowRuntimeId: transactionData.moduleWorkFlowRuntimeId,
          TransactionStatusId: transactionData.transactionStatusId,
          locationName: localdata.locationName,
          storageName: localdata.storageName,
          comment: model.Remarks,
          updatedQuantity: model.updatenewquaninty,
          inventoryDueDate: localStorage.getItem("inventoryduedate"),
          storageArea: localStorage.getItem("storageArea"),


        };
        const offline = await getProductOffline(model.productname)
        if (offline) {
          // updating the product data into indexed Db
          updateProductOffline(payload)
          localStorage.setItem("isofflinelocproductsadded", true)
          setModelHeaderContent(metaDataConstants.productSavedSuccess)
          window.location.reload();
        } else {
          // saving product data into indexed db
          saveProductOffline(payload)
          localStorage.setItem("isofflinelocproductsadded", true)
          setModelHeaderContent(metaDataConstants.productSavedSuccess)
          window.location.reload();
        }
      }
      else {
        setActivateLoader(false);
        setShow(true);
        setServerityStatus("error");
        setMessage(metaDataConstants.productNotInLocationOrStorage);
      }
      setActivateLoader(false);
    }
    focusTextInput();
  };

  const handleInputChange = async (code) => {
    if (isOnline) {
      const payload = {
        UPCCode: code,
      };
      const response = await post(ApiUrls().SEARCH_PRODUCT_BY_UPCCODE, payload).catch(
        function (error) {
          // Handle errors here
          setBarcodeData({
            ...barcodeData,
            barcodenumber: null,
            productid: null,
            productCode: null,
            productname: null,
            inventoryunit: null,
            previousquantity: null,
            unitprice: null,
            updatenewquaninty: '',
            vendorId: null
          });
          setCurrent({
            ...current,
            barcodenumber: '',
            productid: '',
            productCode: '',
            productname: '',
            inventoryunit: '',
            previousquantity: '',
            unitprice: '',
            updatenewquaninty: '',
            Remarks: '',
          });
          setActivateLoader(false);
          console.error("Error:", error);
        }
      );
      if (response?.status === 200) {
        setActivateLoader(false);
        if (response?.data.result.length > 0) {
          console.log("inventoryCheckDataOffline ", inventoryCheckDataOffline);
          const res = inventoryCheckData?.filter(
            (ele) => ele.productId == response?.data.result[0]?.productId
          );
          setUmoID(response?.data.result[0]?.uomId);
          const umoid = response?.data.result[0]?.uomId;
          let data;
          if (umoid == res[0]?.uomId1) {
            console.log(res[0]?.uomEnteredStock1);
            data = {
              barcodenumber: code,
              productid: response?.data.result[0]?.productId,
              productCode: response?.data.result[0]?.productCode,
              productname: response?.data.result[0]?.productName,
              inventoryunit: response?.data.result[0]?.uomName,
              previousquantity: res[0]?.uomEnteredStock1,
              unitprice: response?.data.result[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1: res[0]?.uomEnteredStock1 ,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2: res[0]?.uomEnteredStock2,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3: res[0]?.uomEnteredStock3,
              uomId4: res[0]?.uomId4,
              uomEnteredStock4: res[0]?.uomEnteredStock4,
              uomId6: res[0]?.uomId6,
              uomEnteredStock6: res[0]?.uomEnteredStock6,
              firtstScan: true
            });
          } else if (umoid == res[0]?.uomId2) {
            data = {
              barcodenumber: code,
              productid: response?.data.result[0]?.productId,
              productCode: response?.data.result[0]?.productCode,
              productname: response?.data.result[0]?.productName,
              inventoryunit: response?.data.result[0]?.uomName,
              previousquantity: res[0]?.uomEnteredStock2,
              unitprice: response?.data.result[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1: res[0]?.uomEnteredStock1,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2: res[0]?.uomEnteredStock2 ,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3: res[0]?.uomEnteredStock3,
              uomId4: res[0]?.uomId4,
              uomEnteredStock4: res[0]?.uomEnteredStock4,
              uomId6: res[0]?.uomId6,
              uomEnteredStock6: res[0]?.uomEnteredStock6,
              firtstScan: true
            });
          } else if (umoid == res[0]?.uomId3) {
            data = {
              barcodenumber: code,
              productid: response?.data.result[0]?.productId,
              productCode: response?.data.result[0]?.productCode,
              productname: response?.data.result[0]?.productName,
              inventoryunit: response?.data.result[0]?.uomName,
              previousquantity: res[0]?.uomEnteredStock3,
              unitprice: response?.data.result[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1: res[0]?.uomEnteredStock1,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2: res[0]?.uomEnteredStock2,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3: res[0]?.uomEnteredStock3 ,
              uomId4: res[0]?.uomId4,
              uomEnteredStock4: res[0]?.uomEnteredStock4,
              uomId6: res[0]?.uomId6,
              uomEnteredStock6: res[0]?.uomEnteredStock6,
              firtstScan: true
            });
          } else if (umoid == res[0]?.uomId4) {
            data = {
              barcodenumber: code,
              productid: response?.data.result[0]?.productId,
              productCode: response?.data.result[0]?.productCode,
              productname: response?.data.result[0]?.productName,
              inventoryunit: response?.data.result[0]?.uomName,
              previousquantity: res[0]?.uomEnteredStock4,
              unitprice: response?.data.result[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1: res[0]?.uomEnteredStock1,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2: res[0]?.uomEnteredStock2,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3: res[0]?.uomEnteredStock3,
              uomId4: res[0]?.uomId4,
              uomEnteredStock4: res[0]?.uomEnteredStock4 ,
              uomId6: res[0]?.uomId6,
              uomEnteredStock6: res[0]?.uomEnteredStock6,
              firtstScan: true
            });
          } else if (umoid == res[0]?.uomId5) {
            data = {
              barcodenumber: code,
              productid: response?.data.result[0]?.productId,
              productCode: response?.data.result[0]?.productCode,
              productname: response?.data.result[0]?.productName,
              inventoryunit: response?.data.result[0]?.uomName,
              previousquantity: res[0]?.uomEnteredStock5,
              unitprice: response?.data.result[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1: res[0]?.uomEnteredStock1,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2: res[0]?.uomEnteredStock2,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3: res[0]?.uomEnteredStock3,
              uomId4: res[0]?.uomId4,
              uomEnteredStock4: res[0]?.uomEnteredStock4,
              uomId6: res[0]?.uomId6,
              uomEnteredStock6: res[0]?.uomEnteredStock6 ,
              firtstScan: true
            });
          } else if (umoid == res[0]?.uomId6) {
            data = {
              barcodenumber: code,
              productid: response?.data.result[0]?.productId,
              productCode: response?.data.result[0]?.productCode,
              productname: response?.data.result[0]?.productName,
              inventoryunit: response?.data.result[0]?.uomName,
              previousquantity: res[0]?.uomEnteredStock6,
              unitprice: response?.data.result[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: res[0]?.uomId1,
              uomEnteredStock1: res[0]?.uomEnteredStock1,
              uomId2: res[0]?.uomId2,
              uomEnteredStock2: res[0]?.uomEnteredStock2,
              uomId3: res[0]?.uomId3,
              uomEnteredStock3: res[0]?.uomEnteredStock3,
              uomId4: res[0]?.uomId4,
              uomEnteredStock4: res[0]?.uomEnteredStock4,
              uomId6: res[0]?.uomId6,
              uomEnteredStock6: res[0]?.uomEnteredStock6 ,
              firtstScan: true
            });
          } else {
            data = {
              barcodenumber: code,
              productid: response?.data.result[0]?.productId,
              productCode: response?.data.result[0]?.productCode,
              productname: response?.data.result[0]?.productName,
              inventoryunit: response?.data.result[0]?.uomName,
              previousquantity: 0,
              unitprice: response?.data.result[0]?.sellingPrice,
            };
          }
          setIsShowScan(false);
          setBarcodeData({
            ...barcodeData,
            barcodenumber: data.barcodenumber,
            productid: data.productid,
            productCode: data.productCode,
            productname: data.productname,
            inventoryunit: data.inventoryunit,
            previousquantity: data.previousquantity,
            unitprice: `$${parseFloat(data.unitprice || 0).toFixed(2)}`,
            updatenewquaninty: '',
            vendorId: response?.data.result[0]?.vendorId
          });
          setCurrent({
            ...current,
            barcodenumber: data.barcodenumber,
            productid: data.productid,
            productCode: data.productCode,
            productname: data.productname,
            inventoryunit: data.inventoryunit,
            previousquantity: data.previousquantity,
            unitprice: `$${parseFloat(data.unitprice || 0).toFixed(2)}`,
            updatenewquaninty: '',
          });
        } else {
          setBarcodeData({
            ...barcodeData,
            barcodenumber: null,
            productid: null,
            productCode: null,
            productname: null,
            inventoryunit: null,
            previousquantity: null,
            unitprice: null,
            updatenewquaninty: '',
            vendorId: null
          });
          setCurrent({
            ...current,
            barcodenumber: '',
            productid: '',
            productCode: '',
            productname: '',
            inventoryunit: '',
            previousquantity: '',
            unitprice: '',
            updatenewquaninty: '',
            Remarks: '',
          });
          setShow(true);
          setIsShowScan(false)
          setServerityStatus("error");
          setMessage(metaDataConstants.unrecognizedCProduct);
        }
      } else {
        setActivateLoader(false);
      }
    }
    else {
      const response = barcodeDataDB.filter(
        (ele) => ele.barcode == code
      );
      let dataOffline
      if (response?.length > 0 && response[0]?.barcode != "") {
        let UOMEnteredStock1;
        let UOMEnteredStock2;
        let UOMEnteredStock3;
        let UOMEnteredStock4;
        let UOMEnteredStock5;
        let UOMEnteredStock6;
        let isDataPresent = false
        const offline = await getProductOffline(response[0]?.productName)
        if (offline) {
          isDataPresent = true
          UOMEnteredStock1 = offline?.UOMEnteredStock1
          UOMEnteredStock2 = offline?.UOMEnteredStock2
          UOMEnteredStock3 = offline?.UOMEnteredStock3
          UOMEnteredStock4 = offline?.UOMEnteredStock4
          UOMEnteredStock5 = offline?.UOMEnteredStock5
          UOMEnteredStock6 = offline?.UOMEnteredStock6

        }
        let resp;
        let currentAccountid = localStorage.getItem("account")
        if (response[0]?.vendorId == 0) {
          resp = productStorageDataDB?.filter((el) => el.productId == response[0]?.productId && el.accountId == currentAccountid)
        } else {
          resp = productStorageDataDB?.filter((el) => el.productId == response[0]?.productId && el.vendorId == response[0]?.vendorId && el.accountId == currentAccountid)
        }
        if (resp.length > 0) {
          const id = localStorage.getItem("InventoryCheckId")
          const storageId = localStorage.getItem("LocationStorageId")
          const res = inventoryCheckDataOffline?.filter(
            (ele) => ele.productId == response[0]?.productId && ele.inventoryCheckId == id && ele.locationStorageId == storageId
          );
          setUmoID(response[0]?.uomId);
          setLcationstorage(resp[0]?.locationStorageId)
          const umoid = response[0]?.uomId;
          let data;
          if (umoid == resp[0]?.vpInventoryUnitId1) {
            data = {
              barcodenumber: code,
              productid: response[0]?.productId,
              productCode: response[0]?.productCode,
              productname: response[0]?.productName,
              inventoryunit: response[0]?.uomName,
              previousquantity: isDataPresent == true ? UOMEnteredStock1 : res[0]?.uomEnteredStock1 ? res[0]?.uomEnteredStock1 : 0,
              unitprice: response[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: resp[0]?.vpInventoryUnitId1,
              uomEnteredStock1: isDataPresent == true ? UOMEnteredStock1  : res[0]?.uomEnteredStock1 ? res[0]?.uomEnteredStock1  : 0,
              uomId2: resp[0]?.vpInventoryUnitId2,
              uomEnteredStock2: isDataPresent == true ? UOMEnteredStock2 : res[0]?.uomEnteredStock2 ? res[0]?.uomEnteredStock2 : 0,
              uomId3: resp[0]?.vpInventoryUnitId3,
              uomEnteredStock3: isDataPresent == true ? UOMEnteredStock3 : res[0]?.uomEnteredStock3 ? res[0]?.uomEnteredStock3 : 0,
              uomId4: resp[0]?.vpInventoryUnitId4 ? resp[0]?.vpInventoryUnitId4 : 0,
              uomEnteredStock4: isDataPresent == true ? UOMEnteredStock4 : res[0]?.uomEnteredStock4 ? res[0]?.uomEnteredStock4 : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6: isDataPresent == true ? UOMEnteredStock6 : res[0]?.uomEnteredStock6 ? res[0]?.uomEnteredStock6 : 0,
              firtstScan: true
            });
          } else if (umoid == resp[0]?.vpInventoryUnitId2) {
            data = {
              barcodenumber: code,
              productid: response[0]?.productId,
              productCode: response[0]?.productCode,
              productname: response[0]?.productName,
              inventoryunit: response[0]?.uomName,
              previousquantity: isDataPresent == true ? UOMEnteredStock2 : res[0]?.uomEnteredStock2 ? res[0]?.uomEnteredStock2 : 0,
              unitprice: response[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: resp[0]?.vpInventoryUnitId1,
              uomEnteredStock1: isDataPresent == true ? UOMEnteredStock1 : res[0]?.uomEnteredStock1 ? res[0]?.uomEnteredStock1 : 0,
              uomId2: resp[0]?.vpInventoryUnitId2,
              uomEnteredStock2: isDataPresent == true ? UOMEnteredStock2  : res[0]?.uomEnteredStock2 ? res[0]?.uomEnteredStock2  : 0,
              uomId3: resp[0]?.vpInventoryUnitId3,
              uomEnteredStock3: isDataPresent == true ? UOMEnteredStock3 : res[0]?.uomEnteredStock3 ? res[0]?.uomEnteredStock3 : 0,
              uomId4: resp[0]?.vpInventoryUnitId4 ? resp[0]?.vpInventoryUnitId4 : 0,
              uomEnteredStock4: isDataPresent == true ? UOMEnteredStock4 : res[0]?.uomEnteredStock4 ? res[0]?.uomEnteredStock4 : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6: isDataPresent == true ? UOMEnteredStock6 : res[0]?.uomEnteredStock6 ? res[0]?.uomEnteredStock6 : 0,
              firtstScan: true
            });
          } else if (umoid == resp[0]?.vpInventoryUnitId3) {
            data = {
              barcodenumber: code,
              productid: response[0]?.productId,
              productCode: response[0]?.productCode,
              productname: response[0]?.productName,
              inventoryunit: response[0]?.uomName,
              previousquantity: isDataPresent == true ? UOMEnteredStock3 : res[0]?.uomEnteredStock3 ? res[0]?.uomEnteredStock3 : 0,
              unitprice: response[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: resp[0]?.vpInventoryUnitId1,
              uomEnteredStock1: isDataPresent == true ? UOMEnteredStock1 : res[0]?.uomEnteredStock1 ? res[0]?.uomEnteredStock1 : 0,
              uomId2: resp[0]?.vpInventoryUnitId2,
              uomEnteredStock2: isDataPresent == true ? UOMEnteredStock2 : res[0]?.uomEnteredStock2 ? res[0]?.uomEnteredStock2 : 0,
              uomId3: resp[0]?.vpInventoryUnitId3,
              uomEnteredStock3: isDataPresent == true ? UOMEnteredStock3  : res[0]?.uomEnteredStock3 ? res[0]?.uomEnteredStock3  : 0,
              uomId4: resp[0]?.vpInventoryUnitId4 ? resp[0]?.vpInventoryUnitId4 : 0,
              uomEnteredStock4: isDataPresent == true ? UOMEnteredStock4 : res[0]?.uomEnteredStock4 ? res[0]?.uomEnteredStock4 : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6: isDataPresent == true ? UOMEnteredStock6 : res[0]?.uomEnteredStock6 ? res[0]?.uomEnteredStock6 : 0,
              firtstScan: true
            });
          } else if (umoid == res[0]?.uomId4) {
            data = {
              barcodenumber: code,
              productid: response[0]?.productId,
              productCode: response[0]?.productCode,
              productname: response[0]?.productName,
              inventoryunit: response[0]?.uomName,
              previousquantity: isDataPresent == true ? UOMEnteredStock4 : res[0]?.uomEnteredStock4 ? res[0]?.uomEnteredStock4 : 0,
              unitprice: response[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: resp[0]?.vpInventoryUnitId1,
              uomEnteredStock1: isDataPresent == true ? UOMEnteredStock1 : res[0]?.uomEnteredStock1 ? res[0]?.uomEnteredStock1 : 0,
              uomId2: resp[0]?.vpInventoryUnitId2,
              uomEnteredStock2: isDataPresent == true ? UOMEnteredStock2 : res[0]?.uomEnteredStock2 ? res[0]?.uomEnteredStock2 : 0,
              uomId3: resp[0]?.vpInventoryUnitId3,
              uomEnteredStock3: isDataPresent == true ? UOMEnteredStock3 : res[0]?.uomEnteredStock3 ? res[0]?.uomEnteredStock3 : 0,
              uomId4: resp[0]?.vpInventoryUnitId4 ? resp[0]?.vpInventoryUnitId4 : 0,
              uomEnteredStock4: isDataPresent == true ? UOMEnteredStock4  : res[0]?.uomEnteredStock4 ? res[0]?.uomEnteredStock4  : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6: isDataPresent == true ? UOMEnteredStock6 : res[0]?.uomEnteredStock6 ? res[0]?.uomEnteredStock6 : 0,
              firtstScan: true
            });
          } else if (umoid == res[0]?.uomId5) {
            data = {
              barcodenumber: code,
              productid: response[0]?.productId,
              productCode: response[0]?.productCode,
              productname: response[0]?.productName,
              inventoryunit: response[0]?.uomName,
              previousquantity: isDataPresent == true ? UOMEnteredStock5 : res[0]?.uomEnteredStock5 ? res[0]?.uomEnteredStock5 : 0,
              unitprice: response[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: resp[0]?.vpInventoryUnitId1,
              uomEnteredStock1: isDataPresent == true ? UOMEnteredStock1 : res[0]?.uomEnteredStock1,
              uomId2: resp[0]?.vpInventoryUnitId2,
              uomEnteredStock2: isDataPresent == true ? UOMEnteredStock2 : res[0]?.uomEnteredStock2,
              uomId3: resp[0]?.vpInventoryUnitId3,
              uomEnteredStock3: isDataPresent == true ? UOMEnteredStock3 : res[0]?.uomEnteredStock3,
              uomId4: resp[0]?.vpInventoryUnitId4 ? resp[0]?.vpInventoryUnitId4 : 0,
              uomEnteredStock4: isDataPresent == true ? UOMEnteredStock4 : res[0]?.uomEnteredStock4,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6: isDataPresent == true ? UOMEnteredStock6  : res[0]?.uomEnteredStock6 ? res[0]?.uomEnteredStock6  : 0,
              firtstScan: true
            });
          } else if (umoid == res[0]?.uomId6) {
            data = {
              barcodenumber: code,
              productid: response[0]?.productId,
              productCode: response[0]?.productCode,
              productname: response[0]?.productName,
              inventoryunit: response[0]?.uomName,
              previousquantity: isDataPresent == true ? UOMEnteredStock6 : res[0]?.uomEnteredStock6 ? res[0]?.uomEnteredStock6 : 0,
              unitprice: response[0]?.sellingPrice,
            };
            updateUmoId({
              uomId1: resp[0]?.vpInventoryUnitId1,
              uomEnteredStock1: isDataPresent == true ? UOMEnteredStock1 : res[0]?.uomEnteredStock1 ? res[0]?.uomEnteredStock1 : 0,
              uomId2: resp[0]?.vpInventoryUnitId2,
              uomEnteredStock2: isDataPresent == true ? UOMEnteredStock2 : res[0]?.uomEnteredStock2 ? res[0]?.uomEnteredStock2 : 0,
              uomId3: resp[0]?.vpInventoryUnitId3,
              uomEnteredStock3: isDataPresent == true ? UOMEnteredStock3 : res[0]?.uomEnteredStock3 ? res[0]?.uomEnteredStock3 : 0,
              uomId4: resp[0]?.vpInventoryUnitId4 ? resp[0]?.vpInventoryUnitId4 : 0,
              uomEnteredStock4: isDataPresent == true ? UOMEnteredStock4 : res[0]?.uomEnteredStock4 ? res[0]?.uomEnteredStock4 : 0,
              uomId6: res[0]?.uomId6 ? res[0]?.uomId6 : 0,
              uomEnteredStock6: isDataPresent == true ? UOMEnteredStock6  : res[0]?.uomEnteredStock6 ? res[0]?.uomEnteredStock6  : 0,
              firtstScan: true
            });
          } else {
            data = {
              barcodenumber: code,
              productid: response[0]?.productId,
              productCode: response[0]?.productCode,
              productname: response[0]?.productName,
              inventoryunit: response[0]?.uomName,
              previousquantity: 0,
              unitprice: response[0]?.sellingPrice,
            };
          }
          setIsShowScan(false);
          setBarcodeData({
            ...barcodeData,
            barcodenumber: data.barcodenumber,
            productid: data.productid,
            productCode: data.productCode,
            productname: data.productname,
            inventoryunit: data.inventoryunit,
            previousquantity: data.previousquantity,
            unitprice: `$${parseFloat(data.unitprice || 0).toFixed(2)}`,
            updatenewquaninty: '',
            vendorId: response[0]?.vendorId
          });

          setCurrent({
            ...current,
            barcodenumber: data.barcodenumber,
            productid: data.productid,
            productCode: data.productCode,
            productname: data.productname,
            inventoryunit: data.inventoryunit,
            previousquantity: data.previousquantity,
            unitprice: `$${parseFloat(data.unitprice || 0).toFixed(2)}`,
            updatenewquaninty: '',
          });
        } else {
          setActivateLoader(false);
          setShow(true);
          setServerityStatus("error");
          setMessage(metaDataConstants.productNotInLocationOrStorage);
        }
      } else {
        setBarcodeData({
          ...barcodeData,
          barcodenumber: null,
          productid: null,
          productCode: null,
          productname: null,
          inventoryunit: null,
          previousquantity: null,
          unitprice: null,
          updatenewquaninty: '',
          vendorId: null
        });
        setCurrent({
          ...current,
          barcodenumber: '',
          productid: '',
          productCode: '',
          productname: '',
          inventoryunit: '',
          previousquantity: '',
          unitprice: '',
          updatenewquaninty: '',
          Remarks: '',
        });
        setIsShowScan(false);
        setShow(true);
        setServerityStatus("error");
        setMessage(metaDataConstants.unrecognizedCProduct);
      }
    }
  };
  
  const onChangeHandler = async (event, key, model) => {
    if (key === "barcodenumber") {
      setCurrent({
        ...current,
        barcodenumber: event.target.value,
        productid: null,
        productCode: null,
        productname: null,
        inventoryunit: null,
        previousquantity: null,
        unitprice: null,
        updatenewquaninty: '',
      });
    }
    if (key === "updatenewquaninty") {
      const quantity = event.target.value;
      if (isOnline) {
        const res = inventoryCheckData?.filter(
          (ele) => ele.productId == model.productid
        );
        const updatedqty = barcodeData.previousquantity + parseFloat(quantity);
        if (umoID == res[0]?.uomId1) {
          updateUmoId({ uomEnteredStock1: updatedqty });
        } else if (umoID == res[0]?.uomId2) {
          updateUmoId({ uomEnteredStock2: updatedqty });
        } else if (umoID == res[0]?.uomId3) {
          updateUmoId({ uomEnteredStock3: updatedqty });
        } else if (umoID == res[0]?.uomId4) {
          updateUmoId({ uomEnteredStock4: updatedqty });
        } else if (umoID == res[0]?.uomId5) {
          updateUmoId({ uomEnteredStock6: updatedqty });
        } else if (umoID == res[0]?.uomId6) {
          updateUmoId({ uomEnteredStock6: updatedqty });
        }
      } else {
        const id = localStorage.getItem("InventoryCheckId")
        let resp;
        if (barcodeData?.vendorId == 0) {
          resp = productStorageDataDB?.filter((el) => el.productId == barcodeData.productid && el.accountId == localStorage.getItem("account"))
        } else {
          resp = productStorageDataDB?.filter((el) => el.productId == barcodeData.productid && el.vendorId == barcodeData?.vendorId && el.accountId == localStorage.getItem("account"))
        }

        const res = inventoryCheckDataOffline?.filter(
          (ele) => ele.productId == model.productid && ele.inventoryCheckId == id
        );
        const updatedqty = barcodeData.previousquantity + parseFloat(quantity);
        if (umoID == resp[0]?.vpInventoryUnitId1) {
          updateUmoId({ uomEnteredStock1: updatedqty });
        } else if (umoID == resp[0]?.vpInventoryUnitId2) {
          updateUmoId({ uomEnteredStock2: updatedqty });
        } else if (umoID == resp[0]?.vpInventoryUnitId3) {
          updateUmoId({ uomEnteredStock3: updatedqty });
        } else if (umoID == resp[0]?.vpInventoryUnitId4) {
          updateUmoId({ uomEnteredStock4: updatedqty });
        } else if (umoID == res[0]?.uomId5) {
          updateUmoId({ uomEnteredStock6: updatedqty });
        } else if (umoID == res[0]?.uomId6) {
          updateUmoId({ uomEnteredStock6: updatedqty });
        }
      }
      localStorage.setItem("quantity", parseFloat(quantity));
      setCurrent({
        ...current,
        updatenewquaninty: quantity,
      });
    }
  };
  const onStay = () => {
    setShowModal(false);
    window.location.reload();
  };
  const gotoHome = () => {
    setShowModal(false);
    localStorage.removeItem("account");
    localStorage.removeItem("inventorydate");
    localStorage.removeItem("location");
    localStorage.removeItem("storageArea");
    localStorage.removeItem("inventoryduedate");
    localStorage.removeItem("inventorycounted");
    localStorage.removeItem("InventoryCheckId");
    localStorage.removeItem("LocationStorageId");
    localStorage.removeItem("labelData");
    naviagte(`/home`);
  };
  const onScanSameBarcode = () => {
    setCurrent({
      barcodenumber: "",
      productid: "",
      productCode: "",
      productname: "",
      inventoryunit: "",
      previousquantity: "",
      unitprice: "",
      updatenewquaninty: "",
      Remarks: "",
    });

    focusTextInput();
  };
  const onEnter = () => {
    console.log("onenter");
  };
  const onExit = (e) => {
    console.log("onexit");
  };
  const openCamera = (id, key, obj) => {
    setIsshowButton(true);
    setShowModalCamera(true);
    setImgSrc(null);
  };
  const onClickBarcode = () => {
    if (barcodeData.barcodenumber === barcodeNo) {
      const updatedQuantity = parseInt(localStorage.getItem("quantity"));
      setCurrent({
        ...current,
        barcodenumber: barcodeData.barcodenumber,
        productid: barcodeData.productid,
        productCode: barcodeData.productCode,
        productname: barcodeData.productname,
        inventoryunit: barcodeData.inventoryunit,
        previousquantity: barcodeData.previousquantity,
        unitprice: barcodeData.unitprice,
        updatenewquaninty: updatedQuantity || '',
      });
      localStorage.setItem("quantity", updatedQuantity );
      const updatedQty = barcodeData.previousquantity + updatedQuantity ;
      if (isOnline) {
        const result = inventoryCheckData?.filter(
          (ele) => ele.productId == barcodeData.productid
        );

        if (umoID == result[0]?.uomId1) {
          updateUmoId({ uomEnteredStock1: updatedQty });
        } else if (umoID == result[0]?.uomId2) {
          updateUmoId({ uomEnteredStock2: updatedQty });
        } else if (umoID == result[0]?.uomId3) {
          updateUmoId({ uomEnteredStock3: updatedQty });
        } else if (umoID == result[0]?.uomId4) {
          updateUmoId({ uomEnteredStock4: updatedQty });
        } else if (umoID == result[0]?.uomId5) {
          updateUmoId({ uomEnteredStock6: updatedQty });
        } else if (umoID == result[0]?.uomId6) {
          updateUmoId({ uomEnteredStock6: updatedQty });
        }
      }
      else {
        const id = localStorage.getItem("InventoryCheckId")
        let resp;
        if (barcodeData?.vendorId == 0) {
          resp = productStorageDataDB?.filter((el) => el.productId == barcodeData.productid && el.accountId == localStorage.getItem("account"))
        } else {
          resp = productStorageDataDB?.filter((el) => el.productId == barcodeData.productid && el.vendorId == barcodeData?.vendorId && el.accountId == localStorage.getItem("account"))
        }

        const result = inventoryCheckDataOffline?.filter(
          (ele) => ele.productId == barcodeData.productid && ele.inventoryCheckId == id
        );

        if (umoID == resp[0]?.vpInventoryUnitId1) {
          updateUmoId({ uomEnteredStock1: updatedQty });
        } else if (umoID == resp[0]?.vpInventoryUnitId2) {
          updateUmoId({ uomEnteredStock2: updatedQty });
        } else if (umoID == resp[0]?.vpInventoryUnitId3) {
          updateUmoId({ uomEnteredStock3: updatedQty });
        } else if (umoID == resp[0]?.vpInventoryUnitId4) {
          updateUmoId({ uomEnteredStock4: updatedQty });
        } else if (umoID == result[0]?.uomId5) {
          updateUmoId({ uomEnteredStock6: updatedQty });
        } else if (umoID == result[0]?.uomId6) {
          updateUmoId({ uomEnteredStock6: updatedQty });
        }
      }

    } else if (barcodeData.barcodenumber != null) {
      setCurrent({
        ...current,
        barcodenumber: barcodeNo,
        productid: "",
        productCode: "",
        productname: "",
        inventoryunit: "",
        previousquantity: "",
        unitprice: "",
        updatenewquaninty: "",
      });
      setShow(true);
      setServerityStatus("warning");
      setMessage(
        metaDataConstants.submitPrevProdDetailsThenScan
      );
    } else {
      handleInputChange(barcodeNo);
    }

    setShowModalCamera(false);
    setImgSrc(null);
  };

  const onKeyDownEvent = async (event,key,b,m) => {
    if (key === "barcodenumber") {
      if(event.key == 'Enter'){
        let newValue = event.target.value;
        if (barcodeData.barcodenumber === event.target.value) {
          setIsShowScan(false);
          const updatedQuantity = parseFloat(localStorage.getItem("quantity"));
          setCurrent({
            ...current,
            barcodenumber: barcodeData.barcodenumber,
            productid: barcodeData.productid,
            productCode: barcodeData.productCode,
            productname: barcodeData.productname,
            inventoryunit: barcodeData.inventoryunit,
            previousquantity: barcodeData.previousquantity,
            unitprice: barcodeData.unitprice,
            updatenewquaninty: updatedQuantity || '',
          });
          const updatedQty = barcodeData.previousquantity + updatedQuantity;
          if (isOnline) {
            const result = inventoryCheckData?.filter(
              (ele) => ele.productId == barcodeData.productid
            );
  
            if (umoID == result[0]?.uomId1) {
              updateUmoId({ uomEnteredStock1: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId2) {
              updateUmoId({ uomEnteredStock2: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId3) {
              updateUmoId({ uomEnteredStock3: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId4) {
              updateUmoId({ uomEnteredStock4: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId5) {
              updateUmoId({ uomEnteredStock6: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId6) {
              updateUmoId({ uomEnteredStock6: updatedQty, firtstScan: true });
            }
          } else {
            const id = localStorage.getItem("InventoryCheckId")
            let resp;
            if (barcodeData?.vendorId == 0) {
              resp = productStorageDataDB?.filter((el) => el.productId == barcodeData.productid && el.accountId == localStorage.getItem("account"))
            } else {
              resp = productStorageDataDB?.filter((el) => el.productId == barcodeData.productid && el.vendorId == barcodeData?.vendorId && el.accountId == localStorage.getItem("account"))
            }
            const result = inventoryCheckDataOffline?.filter(
              (ele) => ele.productId == barcodeData.productid && ele.inventoryCheckId == id
            );
            if (umoID == resp[0]?.vpInventoryUnitId1) {
              updateUmoId({ uomEnteredStock1: updatedQty, firtstScan: true });
            } else if (umoID == resp[0]?.vpInventoryUnitId2) {
              updateUmoId({ uomEnteredStock2: updatedQty, firtstScan: true });
            } else if (umoID == resp[0]?.vpInventoryUnitId3) {
              updateUmoId({ uomEnteredStock3: updatedQty, firtstScan: true });
            } else if (umoID == resp[0]?.vpInventoryUnitId4) {
              updateUmoId({ uomEnteredStock4: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId5) {
              updateUmoId({ uomEnteredStock6: updatedQty, firtstScan: true });
            } else if (umoID == result[0]?.uomId6) {
              updateUmoId({ uomEnteredStock6: updatedQty, firtstScan: true });
            }
          }
        } else {
          if (current.barcodenumber && event.target.value.length > current.barcodenumber.length + 5) {
            newValue = newValue.replace(current.barcodenumber, '')
          }
          handleInputChange(newValue);
        }
      }
    }
  }

  return (
    <>
      <Snackbar
        open={showMessage}
        autoHideDuration={centerSnackDuration}
        onClose={() =>
          handleClose({
            vertical: "center",
            horizontal: "right",
          })
        }
      >
        <Alert severity={status}>{servitymessage}</Alert>
      </Snackbar>
      <Snackbar
        open={show}
        autoHideDuration={2000}
        onClose={() =>
          handleClose({
            vertical: "bottom",
            horizontal: "right",
          })
        }
      >
        <Alert severity={serverityStatus}>{message}</Alert>
      </Snackbar>

      <ModalPopup
        show={showModal}
        onHide={() => setShowModal(false)}
        size={"sm"}
        centered={true}
        modelHeader={modelHeaderContent}
        modelContent={
          <div className="footerButtons">
            <p> {metaDataConstants.wantToScanMoreProd}</p>
            <Button
              className="cancelBtn btn Ripple-parent btn btn-primary"
              onClick={onStay}
            >
              {metaDataConstants.yes}
            </Button>
            &nbsp;
            <Button
              className="btn-black btn Ripple-parent btn btn-primary"
              onClick={gotoHome}
            >
              {metaDataConstants.no}
            </Button>
          </div>
        }
        backdrop={"static"}
      />

      <ModalPopup
        show={showModalCamera}
        onHide={() => setShowModalCamera(false)}
        size={"lg"}
        centered={true}
        modelHeader={metaDataConstants.pointCameraAtBarcode}
        modelContent={
          <div className="divRound">
            <div className="clearfix"></div>
            {imgSrc ? (
              <img src={imgSrc} alt="webcam" />
            ) : (
              <Webcam
                className="webCameraDiv"
                videoConstraints={videoConstraints}
                height={500}
                width={600}
                ref={webcamRef}
              />
            )}
            <div className="btn-container">
              {imgSrc ? (
                <button className="btn btn-primary" onClick={retake}>
                  {metaDataConstants.retake}
                </button>
              ) : (
                <button className="btn btn-primary" onClick={capture}>
                  {metaDataConstants.capture}
                </button>
              )}
            </div>
            <Button
              className="cancelBtn btn Ripple-parent btn btn-primary"
              onClick={onClickBarcode}
              disabled={isshowButton}
            >
              {metaDataConstants.submit}
            </Button>
          </div>
        }
        backdrop={"static"}
        //backdrop={"static"} // true, false or 'static'
        scrollable={true} //boolean
        onEnter={onEnter} //Callback fired before the Modal transitions in
        onExit={onExit} //Callback fired right before the Modal transitions out
        closeButtonShow={true}
        parentClassName="ModalBackground"
        headerClassName="ModalHeaderBackground"
        bodyClassName="ModalBodyBackground"
        footerClassName="ModalFooterBackground"
      />
      <div className="container containerMainDiv">
        <div className="contentdivBg p-0">
          <div className="divRound pt-3">

            <div className="clearfix"></div>

            <div className="formData text-left">
              <DynamicForm
                onRef={(ref) => {
                  dyFormRef.current = ref;
                }}
                key={1}
                className="dynamicForm"
                title={metaDataConstants.barcodeInvDetails}
                design="bootrstap"
                buttonSubmit={"Submit"}
                model={candidateDetail}
                onKeyDownText ={onKeyDownEvent}
                disableSubmitOnInValid={!current.barcodenumber || !current.updatenewquaninty}
                defaultValues={current}
                materialOutline={false}
                customValidators={customValidators}
                showAstersikOnRequiredFields={true}
                buttonNormalClick={(id, key, obj) => openCamera(id, key, obj)}
                onSubmit={(model) => onSubmitHandler(model)}
                handleBlur={() => console.log("onblur")}
                onChange={(event, key, model) =>
                  onChangeHandler(event, key, model)
                }
              />
              <div className="lineBtnDiv">
                <Button
                  className="btn"
                  variant="contained"
                  disabled={isshowScan}
                  onClick={onScanSameBarcode}
                >
                  {metaDataConstants.scan}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader active={activateLoader} />
    </>
  );
};
export default ProductDetail;
